import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { RequestManagementService } from '../services/request-management.service';
import 'rxjs/add/operator/map';
import { DealStatusModel } from '../_models/_index';


@Injectable()
export class DealStatusService {

    constructor(private requestManagement: RequestManagementService) { }

    public getDealStatuses(): Promise<DealStatusModel[]> {
        return this.requestManagement.callGetRequest('deals/getDealStatuses',null).map((response: Response) => {
            return <DealStatusModel[]>response.json();
        }).toPromise();
    }  
}



// WEBPACK FOOTER //
// ./src/app/services/deal-status.service.ts